import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-exposure-by-chart',
  templateUrl: './exposure-by-chart.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./exposure-by-chart.component.scss']
})
export class ExposureByChartComponent implements OnInit {
  @Input() taskRequestType: 'group' | 'task' = 'group';
  
  @Output() toggleTaskRequestEmit = new EventEmitter<any>();
  
  constructor() { }

  ngOnInit(): void {
  }

  toggleTaskRequest() {
    this.toggleTaskRequestEmit.emit(true);
  }

}
